import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGeneratePlaneGeometryData(): HsRegularGeometryData {
  const vertices: number[] = [-1, 0, -1, 1, 0, -1, 1, 0, 1, -1, 0, 1, -1, 0, -1, 1, 0, 1];
  const normals: number[] = [0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0];
  return new HsRegularGeometryData(vertices, normals);
}
